/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.10.0
 * @since 1.1.0
 */

import styled from 'styled-components';

import { colors, fonts } from '../../../../../../theme';

export const ExpensesAnalyzerChartTabStyled = styled.div.attrs(({ isActive }: { isActive: boolean }) => ({
    className: `expenses-analyzer__chart-tab ${isActive ? 'active' : ''}`,
}))<{ isActive: boolean }>`
    display: flex;
    justify-content: center;
    min-width: 130px;
    padding: 8px 12px;
    border-right: 1px solid ${colors.borderColorDisabled};
    box-sizing: border-box;
    background: ${colors.backgroundColorWhite};
    cursor: pointer;
    ${fonts.textSmall};
    border-bottom: 1px solid transparent;
    user-select: none;

    &:last-child {
        border-right: none;
    }

    &:hover {
        color: ${colors.borderColorSuccess};
    }

    &.active {
        border-bottom: 1px solid ${colors.borderColorSuccess};
    }

    .page-title__counter {
        ${fonts.textSmall};
        background: ${colors.BrandColorMain};
        border-radius: 20px;
        padding: 0 16px;
        color: #ffffff;
        height: auto;
        margin-bottom: -1px;
    }
`;
